module.exports = __webpack_public_path__ + "img/happy.eefead14.png";